(function(){
  var trigger = document.getElementById('sticky-trigger');
  var sticky  = document.getElementById('stickybar');
  var offer   = document.getElementById('offer');
  var dismissed = false;

  function check(){
    if(dismissed) return;
    var top = trigger.getBoundingClientRect().top;
    var offerTop = offer.getBoundingClientRect().top;
    var show = top < 60 && offerTop > 80;
    sticky.classList.toggle('show', show);
  }
  window.addEventListener('scroll', function(){ requestAnimationFrame(check); }, {passive:true});
  window.addEventListener('resize', check, {passive:true});
  check();
  document.getElementById('stickyclose').addEventListener('click', function(){
    dismissed = true; sticky.classList.remove('show');
  });

  // Desktop rail: fades in at Section 11, gains its CTA button once Section 13 is reached
  var rail = document.getElementById('railcard');
  var cta1 = document.getElementById('sec-cta1');
  if(rail && 'IntersectionObserver' in window){
    var railObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting) rail.classList.add('show'); });
    }, {rootMargin:'0px 0px -60% 0px'});
    railObs.observe(document.getElementById('sec-intro'));

    var ctaObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting) rail.classList.add('cta-active'); });
    }, {rootMargin:'0px 0px -70% 0px'});
    ctaObs.observe(cta1);
  } else if(rail){
    rail.classList.add('show','cta-active');
  }

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(function(item){
    item.querySelector('.faq-q').addEventListener('click', function(){
      item.classList.toggle('open');
      var a = item.querySelector('.faq-a');
      a.style.maxHeight = item.classList.contains('open') ? (a.scrollHeight + 'px') : '0px';
    });
  });

  // CTA click tracking — matches the dataLayer.push pattern used on the Sleep Lines advertorial
  window.dataLayer = window.dataLayer || [];
  document.querySelectorAll('[data-cta]').forEach(function(a){
    a.addEventListener('click', function(){
      window.dataLayer.push({ event: 'advertorial_cta_click', location: a.dataset.cta, href: a.href });
    });
  });
})();
